import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';
import { enableES5 } from 'immer';

import { SettingsProvider } from './ThemeComponents/contexts/SettingsContext';
import { App } from './App';

import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';
import 'rc-time-picker/assets/index.css';

enableES5();

ReactDOM.render(
  <SettingsProvider>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </SettingsProvider>,
  document.getElementById('root')
);
